import { get, getWp, post } from '../../common/ApiClient';
import { NewsletterResponse, SubscribeResponse, SubscribedNewsletterResponse } from '../types/Newsletter';

export const getNewsletterCategories = async (): Promise<NewsletterResponse> => {
  const { data } = await get<NewsletterResponse>('/newsletters/lists', false, {}, {}, 3600);

  return data;
};

export const getPublicNewsletterCategories = async (): Promise<NewsletterResponse> => {
  const { data } = await get<NewsletterResponse>('/newsletters/lists', false, {}, { only_public: true });

  return data;
};

export const getUserNewsLetterCategories = async (): Promise<SubscribedNewsletterResponse> => {
  const { data } = await get<SubscribedNewsletterResponse>('/newsletters/subscribed-lists', true);

  return data;
};

export const getNewslettersByIdArray = async (ids: string, taxonomy: string): Promise<any> => {
  const { data } = await getWp<any>(`/${taxonomy}?include=` + ids + '&per_page=100');
  return data;
};

// used for newsletter subscription (not for authors and topics)
export const subscribeToNewsletter = async (mail_type_code: string): Promise<SubscribeResponse> => {
  let formData = new FormData();
  formData.append('mail_type_code', mail_type_code);

  const { data } = await post<SubscribeResponse>('/mailer/subscribe', true, formData);

  return data;
};

export const subscribeToAuthorOrTopic = async (
  mail_type_code: 'authors' | 'topics',
  variant: number
): Promise<SubscribeResponse> => {
  const variantCode = Array.isArray(variant) ? JSON.stringify(variant) : variant.toString();
  let formData = new FormData();
  formData.append('mail_type_code', mail_type_code);
  formData.append('variant_code', variantCode);

  const { data } = await post<SubscribeResponse>('/mailer/subscribe', true, formData);

  return data;
};

export const bulkSubscribeToAuthorOrTopic = async (
  mail_type_code: 'authors' | 'topics',
  variant: number[]
): Promise<SubscribeResponse> => {
  const variantCode = JSON.stringify(variant);
  let formData = new FormData();
  formData.append('category', mail_type_code);
  formData.append('variants', variantCode);
  formData.append('crm_action', 'subscribe');

  const { data } = await post<SubscribeResponse>('/newsletters/bulk-manage-subscriptions', true, formData);

  return data;
};

// used for newsletter subscription (not for authors and topics)
export const unsubscribeFromNewsletter = async (mail_type_code: string): Promise<SubscribeResponse> => {
  let formData = new FormData();
  formData.append('mail_type_code', mail_type_code);

  const { data } = await post<SubscribeResponse>('/mailer/unsubscribe', true, formData);

  return data;
};

export const unsubscribeFromAuthorOrTopic = async (
  mail_type_code: 'authors' | 'topics',
  variant: number
): Promise<SubscribeResponse> => {
  let formData = new FormData();
  formData.append('mail_type_code', mail_type_code);
  formData.append('variant_code', variant.toString());

  const { data } = await post<SubscribeResponse>('/mailer/unsubscribe', true, formData);

  return data;
};

// @TODO: is it needed?
export const getNewsletterPremiumModalContent = async (): Promise<any> => {
  const data =
    'Donec id elit non mi porta gravida at eget metus. Cras justo odio, dapibus ac facilisis in, egestas eget quam.';

  return data;
};

export const getLatesPostsForAuthor = async (authorId: number): Promise<any> => {
  const { data } = await getWp<any>(`/posts?coauthor=${authorId}&orderby=date&order=desc`);

  return data;
};

export const getUserSubscribedAuthors = async (): Promise<any> => {
  const { data } = await get<any>('/user/bookmarks', true);

  return data;
};
